import script from "./footer-partner-links.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer-partner-links.vue?vue&type=script&setup=true&lang=ts"

import "./footer-partner-links.vue?vue&type=style&index=0&id=5b59ab23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b59ab23"]])

export default __exports__